import { useNavigate } from 'react-router-dom'
import Logo from 'assets/img/logo.svg'
import Button from 'components/Button'
import './index.scss'

const Notfound = () => {
  const navigate = useNavigate()
  return (
    <div className='notfound'>
      <div className="notfound__logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="notfound__content">
        <div className="warning">
          <p>Nie znaleziono takiego kodu</p>
        </div>
        <Button action={() => navigate(-1)} text='Kliknij, aby wrócić do skanera' type='empty' />
      </div>
      <div className="notfound__footer">
      <span onClick={() => window.open('https://mojekondolencje.pl/pomoc')}>Pomoc</span>
              <span onClick={() => window.open('https://mojekondolencje.pl/polityka-prywatnosci')}>Polityka prywatności</span>
              <span onClick={() => window.open('https://mojekondolencje.pl/sklep')}>Sklep</span>
      </div>
    </div>
  )
}

export default Notfound